export const ProfileTabType = {
  Details: "details",
  Edit: "edit",
  Agreements: "agreements",
  Cookies: "cookies",
  Passwords: "pass",
  Facsimile: "facsimile",
  Documents: "documents",
};

export const CareerTheme = {
  Visible: "visible",
  Hidden: "hidden",
};
